import { Component, OnInit, OnChanges, SimpleChanges, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AgrimotorService } from '../../agrimotor.service';

@Component({
  selector: 'app-ag-vehicle-horsebox',
  templateUrl: './vehicle-horsebox.component.html',
  styleUrls: ['./vehicle-horsebox.component.css', '../../../quote.component.css']
})
export class AgVehicleHorseboxComponent implements OnInit, OnChanges {
  @Input() vehicle;
  @Input() staticData;
  @Input() authDetails;
  @Input() modelObj;
  @Input() index;

  frmFields: FormGroup;
  submitted = false;

  constructor(private fb: FormBuilder, private agService: AgrimotorService) { }

  ngOnInit(): void {
    this.buildForm();
    if (this.vehicle) {
      this.patchValues();
    }
    this.frmFields.valueChanges.subscribe(val => {
      if (this.vehicle) {
        Object.assign(this.vehicle, val);
        if (val.extended_use) {
          this.vehicle.extended_use = val.extended_use;
        }
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.frmFields && this.vehicle) {
      this.patchValues();
    }
  }

  buildForm() {
    this.frmFields = this.fb.group({
      registration_number: ['', Validators.required],
      make: ['', Validators.required],
      model: ['', Validators.required],
      year: ['', Validators.required],
      gross_vehicle_weight: ['', Validators.required],
      value: ['', Validators.required],
      cover_type: ['', Validators.required],
      driving_restriction: ['', Validators.required],
      extended_use: this.fb.group({
        personal_business_use: [false],
        livestock_carriage: [false],
        contract_work: [false],
      }),
      green_card: ['', Validators.required],
      mileage: ['', Validators.required],
      is_registered_owner: ['', Validators.required],
      ownership: [''],
      owner_name: [''],
      is_kept_overnight: ['', Validators.required],
      postcode: [''],
      tracker: ['', Validators.required],
      ncd: [''],
    });
  }

  patchValues() {
    this.frmFields.patchValue({
      registration_number: this.vehicle.registration_number || '',
      make: this.vehicle.make || '',
      model: this.vehicle.model || '',
      year: this.vehicle.year || '',
      gross_vehicle_weight: this.vehicle.gross_vehicle_weight || '',
      value: this.vehicle.value || '',
      cover_type: this.vehicle.cover_type || '',
      driving_restriction: this.vehicle.driving_restriction || '',
      extended_use: {
        personal_business_use: this.vehicle.extended_use?.personal_business_use || false,
        livestock_carriage: this.vehicle.extended_use?.livestock_carriage || false,
        contract_work: this.vehicle.extended_use?.contract_work || false,
      },
      green_card: this.vehicle.green_card || '',
      mileage: this.vehicle.mileage || '',
      is_registered_owner: this.vehicle.is_registered_owner || '',
      ownership: this.vehicle.ownership || '',
      owner_name: this.vehicle.owner_name || '',
      is_kept_overnight: this.vehicle.is_kept_overnight || '',
      postcode: this.vehicle.postcode || '',
      tracker: this.vehicle.tracker || '',
      ncd: this.vehicle.ncd || '',
    }, { emitEvent: false });
  }

  get f() { return this.frmFields.controls; }
  get extendedUseControls() { return (this.frmFields.get('extended_use') as FormGroup).controls; }

  lookupVehicle() {
    const regNum = this.frmFields.get('registration_number').value;
    if (regNum) {
      this.agService.getVehicleDetails(regNum, this.authDetails)
        .subscribe((response: any) => {
          if (response.data) {
            this.frmFields.patchValue({
              make: response.data.make || '',
              model: response.data.model || '',
              year: response.data.year || '',
              value: response.data.value || '',
            });
          }
        }, (error) => { });
    }
  }
}
